export default function SearchBar({ onSearch, value, onChange }) {
  const handleKeyDown = (e) => {
    if (e.key === "Enter") onSearch(value);
  };

  return (
    <div className="search-wrap">
      <input
        className="search-input"
        type="text"
        placeholder="Search products..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
      />
      <button className="search-btn" onClick={() => onSearch(value)}>
        Search
      </button>
    </div>
  );
}
